import SharedDialog from '../../shared/shared-dialog';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../shared/pages-config';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface PurchaseLicenseDialogProps {
  open: boolean;
  handleClose: () => void;
  orderNumber: string | null;
}

export default function PurchaseLicenseDialog({
  open,
  handleClose,
  orderNumber,
}: PurchaseLicenseDialogProps) {
  const navigate = useNavigate();
  return (
    <SharedDialog
      open={open}
      handleClose={() => {
        handleClose();
        navigate(
          `/${pagesConfig.billing.link}/${pagesConfig.billingSubscriptions.link}`
        );
      }}
      title="License Confirmation"
      dialogContent={
        <Stack gap={2}>
          {orderNumber && (
            <Typography>
              Order number:{' '}
              <Typography component="span" fontWeight="bold">
                {orderNumber}
              </Typography>
            </Typography>
          )}
          <Typography>
            Your management licenses will be provisioned in 2-5 business days.
            Once your licenses are provisioned you will receive an email from
            Google with further instructions on enrolling your devices.
          </Typography>
          <Typography>
            Please check both email addresses you supplied for your Google
            confirmation email.
          </Typography>
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: () => {
          handleClose();
          navigate(
            `/${pagesConfig.billing.link}/${pagesConfig.billingSubscriptions.link}`
          );
        },
        disabled: false,
        title: 'OK',
      }}
    />
  );
}
